import { useTranslation } from "react-i18next";

import { AuthStatusScreen } from "@/components/auth/AuthStatusScreen";

/**
 * Public landing for buyers redirected back from dLocal — used when the
 * accountant shared a payment link with their client. The buyer is NOT
 * authenticated and won't be, so the page does no API calls, no polling,
 * no auth checks. The accountant's onboarding card reflects the payment
 * once the dLocal webhook updates the backend.
 *
 * `?status=cancelled` is sent when the buyer hits "back" on dLocal.
 */
export function ThankYouPage(): JSX.Element {
  const { t } = useTranslation();
  const params = new URLSearchParams(window.location.search);
  const cancelled = params.get("status") === "cancelled";

  if (cancelled) {
    return (
      <AuthStatusScreen
        state="info"
        title={t("pay.thankYouCancelledTitle", "Pago cancelado")}
        message={t(
          "pay.thankYouCancelledMessage",
          "No se procesó el pago. Si quisiste suscribirte, pedile a tu contador que te comparta el enlace de nuevo.",
        )}
      />
    );
  }

  return (
    <AuthStatusScreen
      state="success"
      title={t("pay.thankYouTitle", "¡Pago recibido!")}
      message={t(
        "pay.thankYouMessage",
        "Activamos tu suscripción. Ya podés cerrar esta ventana.",
      )}
    />
  );
}
